<template>

<com-segment class="diet" segment="diet" :section="section" v-on:close="$emit('close')">

	<p>{{ section.diet.text }}</p>

	<div class="diet-chart">

		<div class="diet-chart-calories" v-tooltip="section.diet.calories.text" v-if="!$isPatient"></div>

		<div class="diet-chart-label" :class="{'is-left': label === 'green' || label === 'red'}" :data-name="label" v-for="label in labels" :key="label">{{ section.diet[label].title }}<span class="diet-chart-label-icon" v-tooltip="section.diet[label].text" v-if="!$isPatient"></span></div>

	</div>

	<div class="diet-details" v-if="$isPatient">

		<div class="diet-details-item">
			<div class="diet-details-title" data-name="calories">Daily Calories</div>
			<div class="diet-details-text" v-html="linkify(section.diet.calories.text)"></div>
		</div>

		<div class="diet-details-item" v-for="label in patientLabels" :key="label">
			<div class="diet-details-title" :data-name="label">{{ section.diet[label].title }}</div>
			<div class="diet-details-text" v-html="linkify(section.diet[label].text)"></div>
		</div>

	</div>

	<com-links :links="section.diet.links" />

</com-segment>

</template>

<script>

import comSegment from './Segment'
import comLinks from './../common/Links'

export default {

	props: ['section'],

	components: {
		'com-segment': comSegment,
		'com-links': comLinks
	},

	data: function() {

		return {
			labels: ['green', 'yellow', 'blue', 'purple', 'red'],
			patientLabels: ['green', 'red', 'purple', 'blue', 'yellow']
		}

	},

	methods: {

		linkify: function(text) {

			if (!text) return ''

			return text.replace(/\[url=([^\]]+)\](.*?)\[\/url\]/g, '<a href="$1" target="_blank">$2</a>')

		}

	}
	
}

</script>

<style scoped>

.diet p {
	color: #343434;
	font-size: 18px;
	line-height: 22px;
	font-weight: 400;
}

.diet-chart {
	width: 434px;
	height: 434px;
	margin: 32px auto 96px auto;
	background-image: url(~@/assets/aid/improve/diet/chart.svg)
}

.diet-chart-label {
	position: absolute;
	font-size: 16px;
	line-height: 19px;
	font-weight: 600;
	width: 100px;
	color: #343434;
}

.diet-chart-calories {
	display: block;
	position: absolute;
	height: 24px;
	left: 130px;
	top: 22px;
	width: 24px;
	background-image: url(~@/assets/info.svg);
	background-size: 24px 24px;
}

.diet-chart-label-icon {
	display: block;
	position: absolute;
	right: -34px;
	top: -3px;
	height: 24px;
	width: 24px;
	background-image: url(~@/assets/info.svg);
	background-size: 24px 24px;
}

.diet-chart-label.is-left {
	text-align: right;
}

.diet-chart-label:not(.is-left) .diet-chart-label-icon {
	right: auto;
	left: -34px;
}

.diet-chart-label[data-name="green"] {
	top: 120px;
	right: 460px;
}

.diet-chart-label[data-name="red"] {
	top: 380px;
	right: 404px;
}

.diet-chart-label[data-name="purple"] {
	top: 446px;
	left: 240px;
}

.diet-chart-label[data-name="yellow"] {
	top: 120px;
	left: 460px;
}

.diet-chart-label[data-name="blue"] {
	top: 380px;
	left: 404px;
}

.diet-details {
	margin-bottom: 32px;
}

.diet-details-item {
	margin-bottom: 16px;
}

.diet-details-title {
	font-size: 16px;
	font-weight: 600;
	color: #343434;
	margin-bottom: 4px;
	padding-left: 15px;
	border-left: 3px solid #ccc;
}

.diet-details-title[data-name="green"] { border-color: #8BC34A; }
.diet-details-title[data-name="yellow"] { border-color: #FFC107; }
.diet-details-title[data-name="blue"] { border-color: #42A5F5; }
.diet-details-title[data-name="purple"] { border-color: #AB47BC; }
.diet-details-title[data-name="red"] { border-color: #EF5350; }
.diet-details-title[data-name="calories"] { border-color: #F8A533; }

.diet-details-text {
	font-size: 16px;
	line-height: 24px;
	color: #343434;
	font-weight: 300;
	padding-left: 17px;
}

.diet-details-text >>> a {
	color: var(--aid-color);
	text-decoration: underline;
	text-underline-offset: 3px;
	font-weight: 600;
	word-break: break-all;
}

.diet-details-text >>> a:hover {
	opacity: 0.7;
}

</style>
